import { mapValues } from 'lodash';
import { useMemo } from 'react';
import { UserRole } from '#/common/types/userTypes';
import useSession from '#/common/hooks/useSession';

export type AccessControl = {
  canCreateCapitalNeed: boolean;
  canUpdateCapitalNeed: boolean;
  canDeleteCapitalNeed: boolean;
};

type AccessKey = keyof AccessControl;

const ACCESS_RESTRICTIONS: Record<AccessKey, UserRole[]> = {
  canCreateCapitalNeed: [UserRole.asset_manager, UserRole.trane_admin],
  canUpdateCapitalNeed: [UserRole.asset_manager, UserRole.trane_admin],
  canDeleteCapitalNeed: [UserRole.asset_manager, UserRole.trane_admin],
};

const getAccessControl = (role?: string | null): AccessControl =>
  mapValues(ACCESS_RESTRICTIONS, (allowedRoles) => allowedRoles.includes(role as UserRole));

const useAccessControl = (): AccessControl => {
  const { user } = useSession();
  const role = user?.role;

  return useMemo(() => getAccessControl(role), [role]);
};

export default useAccessControl;
